import {FC} from 'react'

type Props = {
  two_steps?: boolean
}

const TenantTwoStepsCell: FC<Props> = ({two_steps}) => (
  <> {two_steps && <div className='badge badge-success fs-5 fw-bolder'>Active</div>}</>
)

export {TenantTwoStepsCell}
